import { NgFor, NgIf } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AiAgentResponse } from '../../models/responses/ai-agent-response';
import { MatDialog } from '@angular/material/dialog';
import { OutboundCampaignService } from '../../services/outbound-campaign.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddEditCampaignDialogComponent } from '../ai-assistant-components/add-edit-campaign-dialog/add-edit-campaign-dialog.component';
import { OutboundCampaignResponse } from '../../models/responses/outbound-campaign-response';
import { AiConfigurationPageEventsService } from '../../events/ai-configuration-page-events.service';
import { CallLogListComponent } from '../ai-assistant-components/call-log-list/call-log-list.component';
import { CallLogViewComponent } from '../ai-assistant-components/call-log-view/call-log-view.component';
import { CallLogResponse } from '../../models/responses/call-log-response';

interface DisplayCampaing {
  id: number
  name: string
  date: string
  time: string
  status: string
}
@Component({
  selector: 'app-outboud-campaigns',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    NgFor,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    AddEditCampaignDialogComponent,
    CallLogListComponent,
    CallLogViewComponent

  ],
  templateUrl: './outbound-campaigns.component.html',
  styleUrl: './outbound-campaigns.component.scss'
})
export class OutboudCampaignsComponent {
  @Input() aiAgent!: AiAgentResponse;
  isLoadingArray: boolean[] = [];
  campaigns: DisplayCampaing[] = [];
  selectedCampaign: OutboundCampaignResponse | undefined;
  currentCallLog:CallLogResponse | undefined;
  filteredCampaigns: DisplayCampaing[] = []
  constructor(
    private dialog: MatDialog,
    private outboundCampaignService: OutboundCampaignService,
    private aiAgentPageEventService: AiConfigurationPageEventsService,
    private snackBar: MatSnackBar,
    private aiAgentPageService: AiConfigurationPageEventsService
  ) { }

  ngOnInit() {
    this.initCampaigns();
    this.subscribeToViewComponent();
    this.subscribeToOnCallLogViewBackEvent();
    this.subscribeToOnCallLogBackClickedEvent();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['aiAgent'].currentValue) {
      this.initCampaigns();
    }
  }

  onAddCampaign() {
    this.dialog.open(AddEditCampaignDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.aiAgent }
    })
  }

  applyFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value;
    this.filteredCampaigns = this.campaigns;
    this.filteredCampaigns = this.campaigns.filter(campaign => campaign.name.toLocaleLowerCase().includes(filter.toLowerCase()))
  }

  onDeleteCampaign(id: number, index: number) {
    this.isLoadingArray[index] = true;
    this.outboundCampaignService.deleteBatch(id).subscribe({
      next: () => {
        this.isLoadingArray[index] = false;
        this.snackBar.open('Campaign removed successfully', 'Close', { duration: 5000 });
        this.aiAgentPageEventService.onRefreshAiAgentEvent.emit();
      },
      error: () => {
        alert('Server error, contact support');
        this.isLoadingArray[index] = false;
      }
    })
  }

  subscribeToViewComponent(){
    this.aiAgentPageService.onCampaignCallLogViewClickedEvent.subscribe(callLog=>{
      this.currentCallLog = callLog;
    })
  }
  subscribeToOnCallLogViewBackEvent(){
      this.aiAgentPageService.onCallLogViewBackedClickedEvent.subscribe(() => {
        this.currentCallLog = undefined;
      })
  }

  subscribeToOnCallLogBackClickedEvent(){
    this.aiAgentPageService.onCallLogBackClickedEvent.subscribe(() => {
      this.selectedCampaign = undefined;
    })
}


  onViewSelectedCampaign(id: number) {
    this.selectedCampaign = this.aiAgent.outBoundSettings?.outBoundCampaigns.find(x => x.id == id);
  }
  private initCampaigns() {
    const currentCampaigns = this.aiAgent.outBoundSettings?.outBoundCampaigns;
    if (currentCampaigns) {
      this.campaigns = currentCampaigns.map(x => {
        return { id: x.id, name: x.name, date: new Date(x.executionTime).toDateString(), time: new Date(x.executionTime).toLocaleTimeString(), status: this.capitalizeFirstLetter(x.status) };
      });
      this.filteredCampaigns = this.campaigns;
    }
  }

  capitalizeFirstLetter(string: string) {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
    return "";
  }

}
